import {UserEvent} from './UserEvent';

export class UserFlaggedAsInactive extends UserEvent {}
